import { withNamespaces } from 'react-i18next';
import {
    Col,
    Row,
} from 'reactstrap';

import GeolocationData from 'src/modules/3rd-party-management/components/eudr/geolocation-data';
import SubmissionToTrace from 'src/modules/3rd-party-management/components/eudr/submission-to-trace';
import TopDeforestationHotspotRegions from 'src/modules/3rd-party-management/components/eudr/top-deforestation-hotspot-regions';
import TopRelevantProductsByRiskLevel from 'src/modules/3rd-party-management/components/eudr/top-relevant-products-by-risk-level';
import UpcomingShipmentsMissingDds from 'src/modules/3rd-party-management/components/eudr/upcoming-shipments-missing-dds';

import SummaryWidgets from './components/summary-widgets';
import RiskHeatmap from './components/risk-heatmap';
import SupplierByRiskLevel from './components/supplier-by-risk-level';
import SupplierStatus from './components/supplier-status';
import TradeOperations from './components/trade-operations';

const DEMO_SUPPLIER_ID = 7436;

const EudrDashboard = () => (
    <Row className="g-3 mb-4">
        <Col lg="12">
            <SummaryWidgets />
        </Col>

        <Col xs="12" md="6" lg="3">
            <SupplierStatus />
        </Col>

        <Col xs="12" md="6" lg="3">
            <SupplierByRiskLevel />
        </Col>

        <Col xs="12" md="6" lg="6">
            <SubmissionToTrace />
        </Col>

        <Col xs="12" lg="4">
            <TradeOperations />
        </Col>

        <Col xs="12" lg="8">
            <UpcomingShipmentsMissingDds />
        </Col>

        <Col xs="12">
            <GeolocationData supplierId={DEMO_SUPPLIER_ID} />
        </Col>

        <Col lg="12">
            <RiskHeatmap />
        </Col>

        <Col xs="12" lg="4">
            <TopDeforestationHotspotRegions />
        </Col>

        <Col xs="12" lg="8">
            <TopRelevantProductsByRiskLevel />
        </Col>
    </Row>
);

export default withNamespaces()(EudrDashboard);
